export function mLSIRESOfficeExclusiveListingWaiver() {
return [   //2024 Release 2025-08-29 09:37:46
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "date start date", 
   fontSize: 9,
   type: "date",
   top: 130.44,
   left: 257.64,
   width: 79.32,
   height: 12.96
}
,
{
   page: 0,
   name: "date ending date", 
   fontSize: 9,
   type: "date",
   top: 130.44,
   left: 468.84,
   width: 97.80,
   height: 12.96
}
,
{
   page: 0,
   name: "checkbox 1", 
   isText: false,
   type: "checkbox",
   top: 389.04,
   left: 82.08,
   width: 9.72,
   height: 6.60
}
,
{
   page: 0,
   name: "month", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.52,
   left: 447.36,
   width: 18.48,
   height: 12.96
}
,
{
   page: 0,
   name: "day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.52,
   left: 468.96,
   width: 18.36,
   height: 12.96
}
,
{
   page: 0,
   name: "year", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.52,
   left: 490.44,
   width: 30.36,
   height: 12.96
}
,
{
   page: 0,
   name: "checkbox 2", 
   isText: false,
   type: "checkbox",
   top: 401.28,
   left: 82.08,
   width: 9.72,
   height: 6.60
}
,
{
   page: 0,
   name: "Your Seller Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 603.36,
   left: 149.28,
   width: 268.68,
   height: 12.96
}
,
{
   page: 0,
   name: "Your Property Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 631.8,
   left: 153.48,
   width: 370.331,
   height: 11.411
}
,
{
   page: 0,
   name: "Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 656.84,
   left: 152.36,
   width: 153.12,
   height: 13.615
}
,
{
   page: 0,
   name: "signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 670.912,
   left: 124.364,
   width: 299.892,
   height: 13.491
}
,
{
   page: 0,
   name: "Date brokersign", 
   fontSize: 9,
   type: "date",
   top: 671.876,
   left: 459.493,
   width: 72.763,
   height: 14.145
}
,
{
   page: 0,
   name: "brokerageFirm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 656.512,
   left: 309.02,
   width: 224.618,
   height: 13.491
}
] }
